import { Box, Flex, Text } from "@chakra-ui/react";
import Container from "components/Container";
import { useRelatorioAuditoria } from "core/features/relatorios/hooks/useRelatorioAuditoria";
import { useBreadcrumb } from "features/breadcrumbs";
import { useParams } from "react-router-dom";
import PageHeader from "ui/components/Page/PageHeader";
import LabelItem from "./components/LabelItem";

function RelatorioAuditoriaDetalhes() {

  const { id } = useParams<{ id: string }>();

  useBreadcrumb([
    { name: "Relatórios" },
    {
      name: "Auditoria",
      url: "/relatorios/auditoria",
    },
  ]);

  const { data } = useRelatorioAuditoria(id);

  return (
    <Container>

      <PageHeader
        justifyContent="space-between"
        title={data?.acao}
      />


      <Box>

        <Flex>
          <LabelItem title="Autor" value={data?.pessoa.nome!} />
          <LabelItem title="Data" value={data?.data!} />
        </Flex>

      </Box>


      <Box mt={8} borderRadius={6} bgColor={"#fff"} p={"16px"}>

        <Text mb={4} fontSize={18}>Dados</Text>

        <Flex>
          {[].map((key, index) => <LabelItem key={`${index}`} title={key} value={data?.registro[key]} />)}
        </Flex>

      </Box>

    </Container>
  );
}

export default RelatorioAuditoriaDetalhes;
